import { render, staticRenderFns } from "./florist-requests-table.vue?vue&type=template&id=e408589e"
import script from "./florist-requests-table.vue?vue&type=script&lang=js"
export * from "./florist-requests-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports